<div class="dialog-container">
    <div class="dialog-header">
        <span>KINDLY NOTE</span>
        <button (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="dialog-content">
        <div>
            This service can’t be ordered via the website at this stage — but we’ve got you covered!<br><br>Simply email
            us at <a class="email-address" href="mailto:manager@propertymatrix.co.za">manager@propertymatrix.co.za</a>
            and we'll assist you directly..
        </div>
        <button mat-button (click)="closeDialog()" class="got-it-button">
            Got It
        </button>
    </div>
</div>